export default __webpack_public_path__ + "static/media/role-holder.0f042073.png";